/**
 * Prefetch de páginas internas al pasar el cursor o al tocar (navegación más rápida percibida).
 * Omite carrito/checkout y enlaces externos.
 */
(function () {
  'use strict';
  var prefetched = Object.create(null);
  var hoverTimer;

  /** En móvil, prefetch en cada touchstart satura red y CPU y empeora el scroll al volver de producto. */
  function skipPrefetchOnTouch() {
    try {
      if (typeof navigator !== 'undefined' && navigator.maxTouchPoints > 0) return true;
      if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) return true;
    } catch (e) {}
    return false;
  }
  var noTouchPrefetch = skipPrefetchOnTouch();

  function shouldPrefetch(url) {
    if (!url || prefetched[url]) return false;
    try {
      var u = new URL(url, document.baseURI);
      if (u.origin !== window.location.origin) return false;
      var p = u.pathname;
      if (p.indexOf('/cart') === 0 || p.indexOf('/checkout') === 0 || p.indexOf('/account') === 0) return false;
      return true;
    } catch (e) {
      return false;
    }
  }

  function prefetch(url) {
    if (!shouldPrefetch(url)) return;
    prefetched[url] = true;
    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = url;
    document.head.appendChild(link);
  }

  function onIntent(e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || a.target === '_blank' || a.download) return;
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#' || href.indexOf('javascript:') === 0) return;

    if (e.type === 'touchstart') {
      if (!noTouchPrefetch) prefetch(a.href);
      return;
    }

    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () {
      prefetch(a.href);
    }, 75);
  }

  document.addEventListener('mouseover', onIntent, { passive: true });
  document.addEventListener('touchstart', onIntent, { passive: true, capture: true });
})();
